import compile from 'string-template';
import translate from './translate';

export default function translateError(lang = 'en', key: string, params: Record<string, any> = {}) {
  return compile(translate(lang, `errors.${key}`), params);
}
